export default "__VITE_ASSET__ppNB64z9__"